<script setup lang="ts">
const props = defineProps<{
  faqs: { question: string; answer: string }[];
}>();

useSchemaOrg([
  ...props.faqs.map(faq =>
    defineQuestion({
      name: faq.question,
      acceptedAnswer: faq.answer,
    }),
  ),
]);
</script>

<template>
  <div
    id="faq"
    class="mx-auto my-24 max-w-2xl scroll-mt-10 divide-y divide-gray-900/10 px-6 pb-8 sm:my-32 sm:pb-24 sm:pt-12 lg:max-w-7xl lg:px-8 xl:my-48"
  >
    <h2 class="font-serif text-4xl font-semibold text-gray-900 sm:text-5xl">
      {{ $t('faq.title') }}
    </h2>
    <dl class="mt-10 space-y-8 divide-y divide-gray-900/10">
      <div
        v-for="(faq, fid) in faqs"
        :key="fid"
        class="pt-8 lg:grid lg:grid-cols-12 lg:gap-8"
      >
        <dt class="text-base/7 font-semibold text-gray-900 lg:col-span-5">
          {{ faq.question }}
        </dt>
        <dd class="mt-4 lg:col-span-7 lg:mt-0">
          <p class="text-base/7 text-gray-600">
            {{ faq.answer }}
          </p>
        </dd>
      </div>
    </dl>
  </div>
</template>
